(function () {
  'use strict';

  if (window.LafLightScenes) {
    window.LafLightScenes.init(document);
    return;
  }

  const selector = '[data-laf-light-scene]';
  const instances = new WeakMap();

  function parse(element) {
    try { return element ? JSON.parse(element.textContent) : null; } catch (_) { return null; }
  }

  function imageData(value) {
    if (!value || !value.src || !Number.isFinite(value.width) || !Number.isFinite(value.height)) return false;
    if (value.width < 320 || value.height < 180 || Math.abs(value.width / value.height - 16 / 9) > 0.005) return false;
    try {
      if (new URL(value.src, document.baseURI).protocol !== 'https:') return false;
      if (value.srcset && !value.srcset.split(',').every(function (candidate) {
        const parts = candidate.trim().split(/\s+/);
        return parts.length === 2 && /^\d+w$/.test(parts[1]) && new URL(parts[0], document.baseURI).protocol === 'https:';
      })) return false;
    } catch (_) { return false; }
    return true;
  }

  function initScene(scene) {
    if (instances.has(scene)) return;
    const manifest = parse(scene.querySelector('[data-laf-scene-data]'));
    if (!manifest || manifest.schema !== 1 || String(manifest.product_id) !== scene.dataset.productId || !manifest.variants) return;

    const scope = scene.closest('.shopify-section') || document;
    const form = document.getElementById(scene.dataset.productFormId);
    const idInput = form && form.querySelector('[data-variant-id]');
    if (!form || !idInput || !scope.contains(form) || form.contains(scene)) return;
    const formId = form.getAttribute('id');
    const picker = Array.from(scope.querySelectorAll('[data-variant-picker]')).find(function (element) {
      return element.dataset.formId === formId || form.contains(element);
    });
    const productData = parse(scene.querySelector('[data-laf-scene-product]'));
    const variants = productData && Array.isArray(productData.variants) ? productData.variants : [];
    const optionNames = productData && Array.isArray(productData.optionNames) ? productData.optionNames : [];
    const frame = scene.querySelector('[data-laf-scene-images]');
    const loading = scene.querySelector('[data-laf-scene-loading]');
    const controls = scene.querySelector('[data-laf-scene-controls]');
    const colorFieldset = scene.querySelector('[data-laf-scene-colors]');
    const colorList = scene.querySelector('[data-laf-scene-color-list]');
    const range = scene.querySelector('[data-laf-scene-range]');
    const play = scene.querySelector('[data-laf-scene-play]');
    const playLabel = scene.querySelector('[data-laf-scene-play-label]');
    const selection = scene.querySelector('[data-laf-scene-selection]');
    const status = scene.querySelector('[data-laf-scene-status]');
    if (![frame, loading, controls, colorFieldset, colorList, range, play, playLabel, selection, status].every(Boolean)) return;

    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const positionLabel = scene.dataset.positionLabel || '__PERCENT__%';
    let currentId = '';
    let selectedColor = '';
    let activeKey = '';
    let currentEntry = null;
    let currentColors = [];
    let evening = null;
    let ready = false;
    let destroyed = false;
    let intersected = !('IntersectionObserver' in window);
    let generation = 0;
    let animation = null;
    let playing = false;
    let scheduled = false;
    let observer = null;
    let resizeObserver = null;
    let initializationFrame = null;

    function setPosition(value) {
      const number = Math.max(0, Math.min(100, Number(value) || 0));
      if (evening) evening.style.opacity = String(number / 100);
      range.value = String(Math.round(number));
      range.setAttribute('aria-valuetext', positionLabel.replace('__PERCENT__', String(Math.round(number))));
    }

    function stop() {
      if (animation !== null) window.cancelAnimationFrame(animation);
      animation = null;
      playing = false;
      scene.removeAttribute('data-playing');
      playLabel.textContent = play.dataset.labelPlay;
    }

    function discardImages() {
      frame.querySelectorAll('img').forEach(function (image) { image.remove(); });
      evening = null;
      ready = false;
      controls.hidden = true;
      frame.setAttribute('aria-busy', 'true');
      loading.hidden = false;
    }

    function hide() {
      generation += 1;
      stop();
      discardImages();
      scene.hidden = true;
      activeKey = '';
      currentEntry = null;
      currentColors = [];
      selectedColor = '';
      selection.textContent = '';
      status.textContent = '';
    }

    function entryFor(id) {
      const entry = manifest.variants[String(id)];
      return entry && entry.approved === true && typeof entry.configuration === 'string' && entry.configuration && Array.isArray(entry.colors) ? entry : null;
    }

    function selectedOptions() {
      const result = [];
      if (picker) picker.querySelectorAll('input:checked, select, input[type="hidden"][data-option-index]').forEach(function (input) {
        const index = Number(input.dataset.optionIndex);
        if (Number.isInteger(index) && input.hasAttribute('data-option-index')) result[index] = input.value;
      });
      return result;
    }

    function actualId() {
      const value = String(idInput.value || '');
      const variant = variants.find(function (candidate) { return String(candidate.id) === value; });
      if (!variant || !Array.isArray(variant.options)) return '';
      if (!picker) return value;
      const options = selectedOptions();
      if (!variant.options.every(function (option, index) { return option === options[index]; })) return '';
      return value;
    }

    function visibleControl(element) {
      if (!element || element.disabled || (element.closest && element.closest('fieldset[disabled]'))) return false;
      let surface = element;
      if (element.type === 'radio' && element.labels && element.labels.length) surface = element.labels[0];
      for (let node = surface; node && node !== scope; node = node.parentElement) {
        if (node.hidden || (node.getAttribute && (node.getAttribute('aria-hidden') === 'true' || node.getAttribute('aria-disabled') === 'true'))) return false;
        const style = window.getComputedStyle && window.getComputedStyle(node);
        if (style && (style.display === 'none' || style.visibility === 'hidden' || style.visibility === 'collapse')) return false;
      }
      return !element.hidden;
    }

    function optionInputs(index) {
      return picker ? Array.from(picker.querySelectorAll('[data-option-index]')).filter(function (input) {
        return Number(input.dataset.optionIndex) === index;
      }) : [];
    }

    function offeredOption(index, value) {
      const inputs = optionInputs(index);
      const fixed = inputs.find(function (input) { return input.type === 'hidden'; });
      if (fixed) return fixed.value === value && !fixed.disabled;
      return inputs.some(function (input) {
        if (!visibleControl(input)) return false;
        if (input.tagName === 'SELECT') return Array.from(input.options).some(function (option) {
          return option.value === value && !option.disabled && !option.hidden && !(option.parentElement && option.parentElement.disabled);
        });
        return input.type === 'radio' && input.value === value;
      });
    }

    function lightEvidence(variant) {
      const evidence = [];
      variant.options.forEach(function (rawValue, index) {
        const value = String(rawValue).toLowerCase().replace(/ß/g, 'ss').normalize('NFKD').replace(/[\u0300-\u036f]/g, '');
        const name = String(optionNames[index] || '').toLowerCase();
        const lightOption = /licht|light|emitting|temperature|farbtemperatur/.test(name);
        const range = value.match(/\b([2-6]\d{3})\s*k?\s*(?:[-–—/]|bis|to)\s*([2-6]\d{3})\s*k\b/);
        const cct = /\b(?:3|drei|three)\s*lichtfarben?\b|\btri[ -]?colou?r\b|\b3\s*cct\b/.test(value)
          || (lightOption && /\b(?:3|three)\s*colou?rs?\b/.test(value))
          || (range && Number(range[1]) <= 3500 && Number(range[2]) >= 5000);
        let keys = [];
        if (cct) keys = ['warm', 'neutral', 'cool'];
        else {
          if (/\bwarm[ -]?(?:weiss|white|light)\b/.test(value) || (lightOption && /\bwarm\b/.test(value))) keys.push('warm');
          if (/\bneutral[ -]?(?:weiss|white|light)\b|\bnatural[ -]?(?:white|light)\b/.test(value) || (lightOption && /\bneutral\b/.test(value))) keys.push('neutral');
          if (/\b(?:kalt|cold|cool)[ -]?(?:weiss|white|light)\b/.test(value) || (lightOption && /\b(?:kalt|cold|cool)\b/.test(value))) keys.push('cool');
          const kelvins = Array.from(value.matchAll(/\b([2-6]\d{3})\s*k\b/g)).map(function (match) { return Number(match[1]); });
          if (!keys.length && !range && kelvins.length === 1) keys.push(kelvins[0] <= 3500 ? 'warm' : kelvins[0] < 5000 ? 'neutral' : 'cool');
        }
        if (keys.length) evidence.push({ index: index, value: rawValue, keys: keys });
      });
      if (!evidence.length) return { explicit: false, keys: ['warm'] };
      const offered = picker ? evidence.every(function (item) { return offeredOption(item.index, item.value); }) : true;
      const keys = offered ? evidence.reduce(function (allowed, item) {
        return allowed.filter(function (key) { return item.keys.includes(key); });
      }, ['warm', 'neutral', 'cool']) : [];
      return { explicit: true, keys: !picker && keys.length > 1 ? keys.filter(function (key) { return key === 'warm'; }) : keys };
    }

    function controlPlan(variantId) {
      if (String(variantId) === actualId()) return [];
      if (!picker || picker.dataset.lafVariantReady !== 'true') return null;
      const target = variants.find(function (variant) { return String(variant.id) === String(variantId); });
      if (!target || !target.available || !Array.isArray(target.options)) return null;
      const plan = [];
      for (let index = 0; index < target.options.length; index += 1) {
        const inputs = optionInputs(index);
        const value = target.options[index];
        const immutable = inputs.find(function (input) { return input.type === 'hidden'; });
        if (immutable) {
          if (immutable.disabled || immutable.value !== value) return null;
          continue;
        }
        const select = inputs.find(function (input) { return input.tagName === 'SELECT'; });
        if (select) {
          const option = Array.from(select.options).find(function (item) { return item.value === value && !item.disabled && !item.hidden && !(item.parentElement && item.parentElement.disabled); });
          if (!visibleControl(select) || !option) return null;
          if (select.value !== value) plan.push({ element: select, value: value, previous: select.value });
          continue;
        }
        const radio = inputs.find(function (input) { return input.type === 'radio' && input.value === value && visibleControl(input); });
        if (!radio) return null;
        if (!radio.checked) {
          const checked = inputs.find(function (input) { return input.type === 'radio' && input.checked; });
          plan.push({ element: radio, value: true, previous: checked || null });
        }
      }
      return plan.length ? plan : null;
    }

    function validColors(entry, id) {
      const keys = new Set();
      const own = entry.colors.filter(function (color) { return color && String(color.variant_id) === id; });
      return entry.colors.slice().sort(function (a, b) {
        return Number(Boolean(b) && String(b.variant_id) === id) - Number(Boolean(a) && String(a.variant_id) === id);
      }).filter(function (color) {
        if (!color || typeof color.key !== 'string' || !color.key || keys.has(color.key) || typeof color.label !== 'string' || !color.label.trim()) return false;
        const targetId = String(color.variant_id || '');
        const target = entryFor(targetId);
        const variant = variants.find(function (candidate) { return String(candidate.id) === targetId; });
        if (!target || target.configuration !== entry.configuration || !imageData(color.day) || !imageData(color.evening)) return false;
        if (!variant || !Array.isArray(variant.options)) return false;
        const evidence = lightEvidence(variant);
        const plantScene = !evidence.explicit && targetId === id && own.length === 1 && ['white', 'grow'].includes(color.key);
        if (!plantScene && (!evidence.keys.includes(color.key) || (!evidence.explicit && targetId !== id))) return false;
        if (targetId !== id && controlPlan(targetId) === null) return false;
        keys.add(color.key);
        return true;
      });
    }

    function renderColors() {
      const buttons = Array.from(colorList.querySelectorAll('button'));
      const signature = currentColors.map(function (color) { return color.key + ':' + String(color.variant_id); }).join('|');
      if (colorList.dataset.signature !== signature) {
        colorList.replaceChildren();
        currentColors.forEach(function (color) {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'laf-light-scene__color';
          button.dataset.color = color.key;
          button.textContent = color.label;
          colorList.appendChild(button);
        });
        colorList.dataset.signature = signature;
      }
      const visibleButtons = colorList.dataset.signature === signature && buttons.length === currentColors.length && buttons.every(function (button) { return button.isConnected; })
        ? buttons : Array.from(colorList.querySelectorAll('button'));
      visibleButtons.forEach(function (button) { button.setAttribute('aria-pressed', String(button.dataset.color === selectedColor)); });
      colorFieldset.hidden = currentColors.length < 2;
    }

    function loadImage(data, isEvening) {
      return new Promise(function (resolve, reject) {
        const image = new Image();
        let settled = false;
        const timer = window.setTimeout(function () { finish(false); }, 20000);
        function finish(success) {
          if (settled) return;
          settled = true;
          window.clearTimeout(timer);
          image.onload = null;
          image.onerror = null;
          if (success && image.naturalWidth > 0 && image.naturalHeight > 0 && Math.abs(image.naturalHeight - image.naturalWidth * 9 / 16) <= 1) resolve(image);
          else reject(new Error('Scene image unavailable'));
        }
        image.className = 'laf-light-scene__image' + (isEvening ? ' laf-light-scene__image--evening' : '');
        image.alt = isEvening ? '' : scene.dataset.imageAlt;
        if (isEvening) image.setAttribute('aria-hidden', 'true');
        image.width = data.width;
        image.height = data.height;
        image.decoding = 'async';
        image.loading = 'eager';
        image.fetchPriority = 'low';
        image.sizes = Math.max(280, Math.ceil(frame.clientWidth)) + 'px';
        image.onload = function () { finish(true); };
        image.onerror = function () { finish(false); };
        if (data.srcset) image.srcset = data.srcset;
        image.src = data.src;
        if (image.complete) finish(image.naturalWidth > 0);
      });
    }

    function loadSelected() {
      const color = currentColors.find(function (candidate) { return candidate.key === selectedColor && String(candidate.variant_id) === currentId; });
      if (!color || !currentEntry) { hide(); return; }
      const key = currentId + ':' + color.key + ':' + color.day.src + ':' + color.evening.src;
      if (key === activeKey) return;
      activeKey = key;
      const token = ++generation;
      stop();
      discardImages();
      if (!intersected) { activeKey = ''; return; }
      Promise.all([loadImage(color.day, false), loadImage(color.evening, true)]).then(function (images) {
        if (destroyed || token !== generation || actualId() !== currentId) return;
        frame.appendChild(images[0]);
        frame.appendChild(images[1]);
        evening = images[1];
        ready = true;
        loading.hidden = true;
        controls.hidden = false;
        frame.setAttribute('aria-busy', 'false');
        setPosition(range.value);
      }).catch(function () {
        if (!destroyed && token === generation) hide();
      });
    }

    function refresh(preferredColor) {
      if (destroyed) return;
      const id = actualId();
      const entry = entryFor(id);
      if (!entry) { hide(); return; }
      const sameConfiguration = currentEntry && currentEntry.configuration === entry.configuration;
      const colors = validColors(entry, id);
      const ownColors = colors.filter(function (color) { return String(color.variant_id) === id; });
      const chosen = ownColors.find(function (color) { return color.key === preferredColor; })
        || ownColors.find(function (color) { return sameConfiguration && color.key === selectedColor; })
        || ownColors.find(function (color) { return color.key === entry.default_color; })
        || ownColors[0];
      if (!chosen) { hide(); return; }
      currentId = id;
      currentEntry = entry;
      currentColors = colors;
      selectedColor = chosen.key;
      scene.hidden = false;
      selection.textContent = [entry.configuration_label, chosen.label].filter(function (value) { return typeof value === 'string' && value.trim(); }).join(' · ');
      renderColors();
      loadSelected();
    }

    function scheduleRefresh() {
      if (scheduled || destroyed) return;
      scheduled = true;
      queueMicrotask(function () { scheduled = false; refresh(); });
    }

    function onScopeChange(event) {
      if ((picker && picker.contains(event.target)) || event.target === idInput) scheduleRefresh();
    }

    function chooseColor(event) {
      const button = event.target.closest('button[data-color]');
      if (!button || !colorList.contains(button) || !currentEntry) return;
      if (actualId() !== currentId) { refresh(); return; }
      const color = validColors(currentEntry, currentId).find(function (candidate) { return candidate.key === button.dataset.color; });
      if (!color) return;
      const targetId = String(color.variant_id);
      const plan = controlPlan(targetId);
      if (plan === null) { refresh(); return; }
      if (targetId !== actualId()) {
        plan.forEach(function (change) {
          if (change.element.type === 'radio') change.element.checked = true;
          else change.element.value = change.value;
        });
        plan[plan.length - 1].element.dispatchEvent(new Event('change', { bubbles: true }));
        if (actualId() !== targetId) {
          plan.forEach(function (change) {
            if (change.element.type === 'radio') {
              change.element.checked = false;
              if (change.previous) change.previous.checked = true;
            } else change.element.value = change.previous;
          });
          plan[plan.length - 1].element.dispatchEvent(new Event('change', { bubbles: true }));
          refresh();
          return;
        }
      }
      refresh(color.key);
      status.textContent = selection.textContent;
    }

    function playTransition() {
      if (!ready) return;
      if (playing) { stop(); return; }
      const from = Number(range.value) || 0;
      const destination = from >= 99 ? 0 : 100;
      if (motion.matches) { setPosition(destination); return; }
      let started = null;
      playing = true;
      scene.setAttribute('data-playing', 'true');
      playLabel.textContent = play.dataset.labelStop;
      function step(time) {
        if (!playing || destroyed || !scene.isConnected) { stop(); return; }
        if (started === null) started = time;
        const progress = Math.min(1, (time - started) / 2000);
        const eased = progress < 0.5 ? 2 * progress * progress : 1 - Math.pow(-2 * progress + 2, 2) / 2;
        setPosition(from + (destination - from) * eased);
        if (progress < 1) animation = window.requestAnimationFrame(step);
        else stop();
      }
      animation = window.requestAnimationFrame(step);
    }

    function manualInput() { stop(); setPosition(range.value); }
    function keyboardInput(event) {
      if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End', 'PageUp', 'PageDown'].includes(event.key)) stop();
    }
    function motionChanged() { if (motion.matches) stop(); }
    function visibilityChanged() { if (document.hidden) stop(); }

    range.addEventListener('pointerdown', stop);
    range.addEventListener('keydown', keyboardInput);
    range.addEventListener('input', manualInput);
    range.addEventListener('change', manualInput);
    play.addEventListener('click', playTransition);
    colorList.addEventListener('click', chooseColor);
    scope.addEventListener('change', onScopeChange);
    scope.addEventListener('laf:variant:change', scheduleRefresh);
    document.addEventListener('visibilitychange', visibilityChanged);
    window.addEventListener('popstate', scheduleRefresh);
    if (motion.addEventListener) motion.addEventListener('change', motionChanged);
    else if (motion.addListener) motion.addListener(motionChanged);

    if (!intersected) {
      observer = new IntersectionObserver(function (entries) {
        if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
        intersected = true;
        observer.disconnect();
        loadSelected();
      }, { rootMargin: '200px 0px' });
      observer.observe(scene);
    }

    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(function () {
        const size = Math.max(280, Math.ceil(frame.clientWidth)) + 'px';
        frame.querySelectorAll('img').forEach(function (image) {
          if (image.sizes !== size) image.sizes = size;
        });
      });
      resizeObserver.observe(frame);
    }

    const api = {
      refresh: refresh,
      destroy: function () {
        destroyed = true;
        generation += 1;
        stop();
        if (observer) observer.disconnect();
        if (resizeObserver) resizeObserver.disconnect();
        if (initializationFrame !== null) window.cancelAnimationFrame(initializationFrame);
        range.removeEventListener('pointerdown', stop);
        range.removeEventListener('keydown', keyboardInput);
        range.removeEventListener('input', manualInput);
        range.removeEventListener('change', manualInput);
        play.removeEventListener('click', playTransition);
        colorList.removeEventListener('click', chooseColor);
        scope.removeEventListener('change', onScopeChange);
        scope.removeEventListener('laf:variant:change', scheduleRefresh);
        document.removeEventListener('visibilitychange', visibilityChanged);
        window.removeEventListener('popstate', scheduleRefresh);
        if (motion.removeEventListener) motion.removeEventListener('change', motionChanged);
        else if (motion.removeListener) motion.removeListener(motionChanged);
        instances.delete(scene);
      }
    };
    instances.set(scene, api);
    scene.setAttribute('data-laf-scene-ready', 'true');
    scene.setAttribute('data-laf-scene-color-policy', 'offered-variants-v1');
    setPosition(0);
    refresh();
    initializationFrame = window.requestAnimationFrame(function () {
      initializationFrame = null;
      refresh();
    });
  }

  function eachScene(root, callback) {
    if (root.matches && root.matches(selector)) callback(root);
    root.querySelectorAll(selector).forEach(callback);
  }

  function init(root) { eachScene(root || document, initScene); }
  window.LafLightScenes = {
    init: init,
    refresh: function (root) {
      eachScene(root || document, function (scene) {
        const api = instances.get(scene);
        if (api) api.refresh();
      });
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    eachScene(event.target, function (scene) {
      const api = instances.get(scene);
      if (api) api.destroy();
    });
  });
})();
